import axios from "axios";

import { TIMEOUT } from "../config/constants";

export default axios.create({
  baseURL: process.env.REACT_APP_GATEWAY_SERVER_API,
  timeout: TIMEOUT
});
